/**
 * Routes served to strangers rather than to signed-in users.
 *
 * Product analytics answer what a customer does inside the product. Nobody on
 * these pages is inside the product — they are a visitor reading a chat — so
 * loading a product-analytics SDK there records nothing and costs them the
 * download and parse anyway. Measured on the live assistant page, Mixpanel was
 * 421KB, the third-largest thing on it.
 *
 * Marketing attribution for these visitors is unaffected: it runs through the
 * tracking pixel and Tag Manager, which are separate.
 *
 * Its own module rather than living in main.tsx so it can be tested without
 * importing the app bootstrap, which mounts React on import.
 */
export const ANONYMOUS_ROUTE_PREFIXES = ['/assistant', '/ai-demo', '/s/'];

/**
 * Global the assistant app raises on mount so the embeddable widget knows it is
 * sitting on top of a conversation and should stay out of the way. A global
 * rather than an import because the widget is a separate bundle running on
 * whatever page it was embedded in.
 */
export const ASSISTANT_SURFACE_FLAG = '__nynchAssistantSurface';

export function isAnonymousSurface(pathname: string): boolean {
  return ANONYMOUS_ROUTE_PREFIXES.some((prefix) => {
    // Compared segment-wise, so /assistants-report is not swallowed by the
    // /assistant prefix.
    const normalised = prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
    return pathname === normalised || pathname.startsWith(`${normalised}/`);
  });
}
